var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgRejectsAging = function SvgRejectsAging(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129 142.5H12L35.1 22.5H152L129 142.5Z",
    fill: "#E6E6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 126H15L14 132H131L132 126Z",
    fill: "#9FA4D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9 125H78.7C80.3 125 81.6 123.7 81.6 122.1V37.5C81.6 35.9 80.3 34.6 78.7 34.6H30.9C22.7 34.6 16 41.3 16 49.5V122.1C16 123.7 17.3 125 18.9 125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7 126.5H18.9C16.5 126.5 14.5 124.5 14.5 122.1V49.5C14.5 40.5 21.8 33.2 30.8 33.2H78.7C81.1 33.2 83.1 35.2 83.1 37.6V122.2C83.1 124.5 81.1 126.5 78.7 126.5ZM30.9 36.1C23.5 36.1 17.6 42.1 17.6 49.4V122C17.6 122.8 18.2 123.4 19 123.4H78.8C79.6 123.4 80.2 122.8 80.2 122V37.5C80.2 36.7 79.6 36.1 78.8 36.1H30.9Z",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 50.5H30.8004V34.6C30.9004 34.6 15.4004 36.6 16.0004 50.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8999 52H15.9999C15.1999 52 14.4999 51.4 14.4999 50.6C13.7999 35.5 30.4999 33.2 30.6999 33.2C31.0999 33.1 31.5999 33.3 31.8999 33.6C32.1999 33.9 32.3999 34.3 32.3999 34.7V50.6C32.3999 51.3 31.6999 52 30.8999 52ZM17.4999 49H29.3999V36.5C25.7999 37.4 17.8999 40.3 17.4999 49Z",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7537 109.827L66.5537 109.827L66.5537 100.327L32.7537 100.327L32.7537 109.827Z",
    fill: "#DBC553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0002 111.4H31.2002V98.9H68.0002V111.4ZM34.2002 108.4H65.0002V101.9H34.2002V108.4Z",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9998 84.9L55.0998 76L63.6998 67.4L58.2998 62.1L49.7998 70.7L40.8998 61.8L35.5998 67.1L44.4998 76L35.2998 85.2L40.5998 90.5L49.7998 81.3L58.6998 90.2L63.9998 84.9Z",
    fill: "#E3A09B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6002 92.7L33.2002 85.3L42.4002 76.1L33.5002 67.2L40.9002 59.8L49.8002 68.7L58.4002 60.2L65.8002 67.6L57.2002 76L66.1002 84.9L58.7002 92.3L49.8002 83.4L40.6002 92.7ZM37.4002 85.2L40.6002 88.4L49.8002 79.2L58.7002 88.1L61.9002 84.9L53.0002 76L61.6002 67.4L58.4002 64.2L49.8002 72.8L40.9002 63.9L37.7002 67.1L46.6002 76L37.4002 85.2Z",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 125C8 124.2 8.7 123.5 9.5 123.5H136.5C137.3 123.5 138 124.2 138 125C138 125.8 137.3 126.5 136.5 126.5H9.5C8.7 126.5 8 125.8 8 125Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5 58.7H130.5V118.5C130.5 122.3 127.4 125.4 123.6 125.4H83.4C79.6 125.4 76.5 122.3 76.5 118.5V58.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75 57.2H132V118.5C132 123.1 128.2 126.9 123.6 126.9H83.4C78.8 126.9 75 123.1 75 118.5V57.2ZM78 60.2V118.5C78 121.4 80.4 123.9 83.4 123.9H123.6C126.5 123.9 129 121.5 129 118.5V60.2H78Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8 41.1H136.1C138.5 41.1 140.4 43 140.4 45.4V54.4C140.4 56.8 138.5 58.7 136.1 58.7H70.8C68.4 58.7 66.5 56.8 66.5 54.4V45.4C66.5 43.1 68.4 41.1 70.8 41.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8 42.6C69.3 42.6 68 43.9 68 45.4V54.4C68 56 69.2 57.2 70.8 57.2H136.1C137.7 57.2 138.9 56 138.9 54.4V45.4C138.9 43.8 137.7 42.6 136.1 42.6H70.8ZM65 45.4C65 42.2 67.7 39.6 70.8 39.6H136.1C139.4 39.6 141.9 42.2 141.9 45.4V54.4C141.9 57.7 139.3 60.2 136.1 60.2H70.8C67.5 60.2 65 57.6 65 54.4V45.4Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3996 18.5H126.5C131.6 18.5 135.8 22.7 135.8 27.8V41.1H71.0996V27.8C71.0996 22.7 75.1996 18.5 80.3996 18.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3996 20C75.9996 20 72.5996 23.5 72.5996 27.8V39.6H134.3V27.8C134.3 23.5 130.8 20 126.5 20H80.3996ZM69.5996 27.8C69.5996 21.9 74.3996 17 80.3996 17H126.5C132.4 17 137.3 21.9 137.3 27.8V42.6H69.5996V27.8Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.4 27.3C124.2 27.3 124.9 28 124.9 28.8V41.2C124.9 42 124.2 42.7 123.4 42.7C122.6 42.7 121.9 42 121.9 41.2V28.8C121.9 28 122.6 27.3 123.4 27.3Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.7 27.3C110.5 27.3 111.2 28 111.2 28.8V41.2C111.2 42 110.5 42.7 109.7 42.7C108.9 42.7 108.2 42 108.2 41.2V28.8C108.2 28 108.9 27.3 109.7 27.3Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7002 27.3C97.5002 27.3 98.2002 28 98.2002 28.8V41.2C98.2002 42 97.5002 42.7 96.7002 42.7C95.9002 42.7 95.2002 42 95.2002 41.2V28.8C95.2002 28 95.9002 27.3 96.7002 27.3Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.5 27.3C84.3 27.3 85 28 85 28.8V41.2C85 42 84.3 42.7 83.5 42.7C82.7 42.7 82 42 82 41.2V28.8C82 28 82.7 27.3 83.5 27.3Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9004 122.9C96.5004 122.9 90.5004 121.2 90.5004 114C90.5004 106.8 90.5004 60.5 90.5004 60.5H79.9004V115.8C80.0004 120.8 81.8004 122.9 85.2004 122.9",
    fill: "#FEEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5002 66.8H116.6C117.9 66.8 118.9 67.8 118.9 69.1V80C118.9 81.3 117.9 82.3 116.6 82.3H99.5002C98.2002 82.3 97.2002 81.3 97.2002 80V69.3C97.2002 67.9 98.2002 66.8 99.5002 66.8Z",
    fill: "#F9AF8D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.5002 68.3C99.1002 68.3 98.7002 68.6 98.7002 69.2V80C98.7002 80.5 99.0002 80.8 99.5002 80.8H116.6C117.1 80.8 117.4 80.5 117.4 80V69.2C117.4 68.7 117.1 68.4 116.6 68.4H99.5002V68.3ZM95.7002 69.3C95.7002 67.2 97.3002 65.4 99.5002 65.4H116.6C118.8 65.4 120.4 67.1 120.4 69.2V80C120.4 82.2 118.7 83.8 116.6 83.8H99.5002C97.3002 83.8 95.7002 82.1 95.7002 80V69.3Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.4 70.3H104.4C106.2 70.3 107.6 71 107.6 73C107.6 74.2 107 75 106 75.4L107.9 78.7H105.8L104.1 75.7H103.1V78.7H101.2V70.3H101.4ZM104.3 74.2C105.3 74.2 105.9 73.8 105.9 73C105.9 72.2 105.3 71.9 104.3 71.9H103.3V74.2H104.3Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.2 70.2H104.4C105.3 70.2 106.1 70.4 106.7 70.8C107.3 71.2 107.7 71.9 107.7 73C107.7 73.6 107.6 74.1 107.3 74.6C107 75 106.7 75.3 106.2 75.5L108.1 78.9H105.8L104.1 75.9H103.3V78.9H101.2V70.2ZM101.4 70.4V78.6H103V75.6H104.2L105.9 78.6H107.8L105.9 75.3H106C106.5 75.1 106.9 74.8 107.1 74.4C107.4 74 107.5 73.5 107.5 72.9C107.5 71.9 107.2 71.3 106.6 70.9C106 70.5 105.3 70.3 104.4 70.3H101.4V70.4ZM103.2 71.7H104.3C104.8 71.7 105.2 71.8 105.5 72C105.8 72.2 105.9 72.5 105.9 72.9C105.9 73.3 105.8 73.6 105.5 73.9C105.2 74.1 104.8 74.2 104.3 74.2H103.2V71.7ZM103.4 71.9V74H104.3C104.8 74 105.1 73.9 105.4 73.7C105.6 73.5 105.8 73.2 105.8 72.9C105.8 72.5 105.7 72.3 105.4 72.1C105.2 71.9 104.8 71.9 104.3 71.9H103.4Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2 75.4L108.3 72.3H110.3L110.9 73.3C111.1 73.6 111.2 74.1 111.5 74.4C111.6 74.1 111.8 73.6 111.9 73.3L112.3 72.3H114.3L112.4 75.6L114.4 78.7H112.4L111.7 77.6C111.5 77.3 111.3 76.8 111.1 76.5C111 76.8 110.8 77.3 110.7 77.6L110.1 78.7H108.1L110.2 75.4Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.2 72.2H110.4L111 73.2C111.1 73.4 111.2 73.6 111.3 73.8C111.4 73.9 111.4 74 111.5 74.2C111.5 74.1 111.6 74 111.6 73.8C111.7 73.6 111.8 73.4 111.8 73.3L112.3 72.2H114.5L112.6 75.6L114.7 78.8H112.5L111.8 77.6C111.6 77.3 111.5 77 111.3 76.7C111.3 76.8 111.2 76.9 111.2 77C111.1 77.2 111 77.4 111 77.5L110.4 78.7H108.2L110.3 75.3L108.2 72.2ZM108.5 72.4L110.3 75.4L108.4 78.6H110.2L110.7 77.6C110.8 77.4 110.8 77.2 110.9 77C111 76.8 111.1 76.6 111.1 76.5L111.2 76.2L111.3 76.5C111.4 76.8 111.6 77.3 111.8 77.6L112.4 78.7H114.2L112.3 75.7L114.1 72.5H112.3L111.9 73.4C111.8 73.6 111.8 73.8 111.7 74C111.6 74.2 111.5 74.4 111.5 74.5L111.4 74.7L111.3 74.5C111.2 74.3 111.1 74.1 111 73.9C110.9 73.7 110.8 73.5 110.7 73.4L110.2 72.5H108.5V72.4Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7004 89.4H119.7C120.7 89.4 121.5 90.2 121.5 91.2V110.5C121.5 111.5 120.7 112.3 119.7 112.3H87.7004C86.7004 112.3 85.9004 111.5 85.9004 110.5V91.2C85.9004 90.2 86.7004 89.4 87.7004 89.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.4996 91.1V110.5C87.4996 110.6 87.4996 110.7 87.5996 110.7C87.5996 110.7 87.6997 110.8 87.7997 110.8H119.8C119.9 110.8 120 110.8 120 110.7C120 110.7 120.1 110.6 120.1 110.5V91.2C120.1 91.1 120.1 91 120 91C120 91 119.9 90.9 119.8 90.9H87.7997C87.5997 90.9 87.4996 91 87.4996 91.1ZM84.4996 91.3C84.2996 89.2 86.0997 88 87.7997 88H119.8C121.6 88 123.1 89.4 123.1 91.3V110.6C123.1 112.4 121.7 113.9 119.8 113.9H87.7997C85.9997 113.9 84.4996 112.5 84.4996 110.6V91.3Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.7998 97C89.7998 96.2 90.4998 95.5 91.2998 95.5H114.5C115.3 95.5 116 96.2 116 97C116 97.8 115.3 98.5 114.5 98.5H91.2998C90.4998 98.5 89.7998 97.8 89.7998 97Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.7998 103.9C89.7998 103.1 90.4998 102.4 91.2998 102.4H107.4C108.2 102.4 108.9 103.1 108.9 103.9C108.9 104.7 108.2 105.4 107.4 105.4H91.2998C90.4998 105.4 89.7998 104.7 89.7998 103.9Z",
    fill: "#313E48"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 125.5,
    fill: "white",
    transform: "translate(8 17)"
  })))));
};
export { SvgRejectsAging as ReactComponent };
export default __webpack_public_path__ + "static/media/rejects-aging.e45e675d.svg";